import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "-mt-10 -mb-4" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import OptionDetails from './modals/OptionDetails.vue' // components

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'
	
	import { // vue
		computed,
		ref
	} from 'vue'

	
	const __default__ = { name: 'JobOptions' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {
	
	const props = __props

	const _localesStore = localesStore()

	const {t} = useI18n()

	const optionDetailsBreadcrumb = computed(() => {
		return [
			{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
			{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
			{label: _localesStore.getLabel('175'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }} // options
		]
	})

	const selectedOption = ref({})
	const optionDetailsModal = ref<{open: boolean}>({open: false})


	function openModalDetails(row: any) {
		selectedOption.value = row
		optionDetailsModal.value.open = true
	}
	
	function hasPicture(row: any) {
		return row?.['job__JOBS_OPTIONS__jobID::s3JSONPicture'] || row?.['job__job_option__CONTACTS_OPTIONS__contactOptionsID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['job__JOBS_OPTIONS__jobID::s3JSONVideo'] || row?.['job__job_option__CONTACTS_OPTIONS__contactOptionsID::s3JSONVideo']
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noOptions'),
      data: props?.job?.portalData?.portal_options,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('329'),
          prop: "job__job_option__SERVICES_OPTIONS_serviceOptionID::name_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('411')
        }, {
          default: _withCtx(({row}) => [
            (row['job__JOBS_OPTIONS__jobID::standard'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('11'),
          prop: "job__job_option__contact_option__SERVICES_OPTIONS__serviceOptionID::category_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('190'),
          prop: "job__job_option__contact_option__SERVICES_OPTIONS__serviceOptionID::description_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetails(row))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_0,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetails(row))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasVideo(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_1,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"]),
    _createVNode(_component_tw_modal, {
      title: selectedOption.value?.['job__job_option__SERVICES_OPTIONS_serviceOptionID::name_display'],
      breadcrumb: optionDetailsBreadcrumb.value,
      ref_key: "optionDetailsModal",
      ref: optionDetailsModal
    }, {
      default: _withCtx(() => [
        _createVNode(OptionDetails, { option: selectedOption.value }, null, 8, ["option"])
      ]),
      _: 1
    }, 8, ["title", "breadcrumb"])
  ]))
}
}

})